import React from 'react';

import Checkbox from '../../../components/Checkbox';
import { HotComputedCellValue } from '../../../../common/table/TableTypes';
import type { MNHotInstance } from '../tableHotInstanceTypes';

import './CellCheckboxRenderer.scss';

type HandledMouseEvent = React.MouseEvent<HTMLDivElement> & {
    handled?: boolean;
};

type Props = {
    row: number;
    col: number;
    hotComputedCellValue: HotComputedCellValue;
    hotTableInstance: MNHotInstance;
    isEditable?: boolean;
};

const CellCheckboxRenderer: React.FC<Props> = (props) => {
    const { row, col, hotComputedCellValue, hotTableInstance, isEditable = true } = props;

    const value =
        hotComputedCellValue === true ||
        (hotComputedCellValue !== null && hotComputedCellValue.toString().toLowerCase() === 'true');

    const handleClick = (event: HandledMouseEvent) => {
        event.handled = true;

        if (!isEditable) return;

        // Since checkbox can be immediately toggled (without the cell being selected first), there is a
        // possibility of the checkbox being clicked while another cell is being edited. This will cause
        // `beforeChange` to be called twice very quickly, causing changes in the edited cell to be reverted.
        //
        // The delay here is to give time for other cells to finish editing before we update the checkbox.
        setTimeout(() => {
            hotTableInstance.setDataAtCell(row, col, (!value).toString());
        }, 50);
    };

    return (
        <div className="CellCheckboxRenderer">
            <Checkbox checked={value} onClick={handleClick} />
        </div>
    );
};

export default CellCheckboxRenderer;
